module.exports = __webpack_public_path__ + "static/img/centerRoundBig.c680e89a.png";